module.exports = __webpack_public_path__ + "img/lupa_active.svg";